export const CONFIGURABLE_PAGES = [
  { slug: "dashboard", label: "Dashboard" },
  { slug: "clients", label: "Clients" },
  { slug: "queue", label: "Saturday Queue" },
  { slug: "pending", label: "Pending Updates" },
  { slug: "reports", label: "Reports" },
  { slug: "sharing-tree", label: "Sharing Tree" },
  { slug: "import", label: "Import" },
  { slug: "audit", label: "Audit Log" },
  { slug: "settings", label: "Settings" },
  { slug: "kiosk", label: "Kiosk Display" },
];

export const ALL_SLUGS = CONFIGURABLE_PAGES.map(p => p.slug);

export const VIEWER_RESTRICTED_PAGES = [
  "sharing-tree", "import", "audit", "settings", "users", "queue", "kiosk",
];

export function canUseStaffPage(user, slug) {
  if (!user) return false;
  if (user.role === "admin") return true;
  if (user.role === "viewer" && VIEWER_RESTRICTED_PAGES.includes(slug)) return false;
  if (["queue", "kiosk"].includes(slug) && user.role !== "staff") return false;
  return user.page_permissions == null || user.page_permissions.includes(slug);
}

// Use the same role and page rules as direct-route guards. Never fall back to
// Profile/Help just because those shared utility routes remain accessible.
export function getStaffLandingPath(user) {
  const page = CONFIGURABLE_PAGES.find(({ slug }) => canUseStaffPage(user, slug));
  return page ? `/staff/${page.slug}` : "/staff/no-pages";
}
